import { makeStyles } from '@material-ui/core';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
  drawer: {
    position: 'fixed',
    left: 0,
    height: '100%',
    zIndex: theme.zIndex.drawer,
    overflowX: 'hidden',
    width: 48,
    paddingTop: 40,
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.primary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundColor: theme.palette.primary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingTop: 48,
  },
}));
